document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      showRemoveModal: false,
      removeItemKey: null,
      removeItemTitle: '',
      removeOriginalTarget: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          const updatedProductQuantities = e.detail.response.items.map(item=>{
            return {
              id: item.id,
              quantity: item.quantity
            }
          })
          const updateB2bProductQuantitiesEvent = new CustomEvent('updateB2bProductQuantities', { detail: updatedProductQuantities })
          document.dispatchEvent(updateB2bProductQuantitiesEvent);
          
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });

        window.addEventListener('shapes:cart:freegiftadded', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });
      },
      openRemoveModal(key, title, originalTarget) {
        this.removeItemKey = key;
        this.removeItemTitle = title;
        this.removeOriginalTarget = originalTarget || null;
        this.showRemoveModal = true;
        let paddingRight = document.documentElement.style.paddingRight;
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
        document.documentElement.style.overflow = 'hidden';
        // trap focus if needed
        this.$nextTick(() => {
          // focus first button inside modal
          const modal = document.querySelector('[x-show]');
          if (modal) {
            const btn = modal.querySelector('button');
            if (btn) btn.focus();
          }
        });
      },
      closeRemoveModal() {
        this.showRemoveModal = false;
        this.removeItemKey = null;
        this.removeItemTitle = '';
        this.removeOriginalTarget = null;
        document.documentElement.style.paddingRight = paddingRight;
        document.documentElement.style.overflow = '';
      },
      confirmRemove() {
        if (!this.removeItemKey) return this.closeRemoveModal();
        // reuse existing removal flow by dispatching change with quantity 0
        this.itemQuantityChange(this.removeItemKey, 0);
        this.closeRemoveModal();
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        // Resolve the line item and input element. When called from the modal
        // we get a key; otherwise this.$el is the input element that triggered change.
        let lineItemEl = null;
        let inputEl = null;

        if (key) {
          lineItemEl = this.itemsRoot.querySelector(`li[data-cart-item-key="${key}"]`);
          if (lineItemEl) inputEl = lineItemEl.querySelector('input[type="number"]');
        } else {
          lineItemEl = this.$el.closest('li[data-cart-item-key]');
          inputEl = this.$el;
        }

        const id = key ? key : lineItemEl ? lineItemEl.getAttribute('data-cart-item-key') : null;
        const quantity = parseInt(!isNaN(value) ? value : (inputEl ? inputEl.value : 0), 10);
        const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('javascript');

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = inputEl ? parseInt(inputEl.dataset.lastValue, 10) : NaN;

        if (quantity !== lastValue) {
          if (lineItemEl) lineItemEl.classList.add('opacity-50', 'cursor-progress');

          this.locked = lineItemEl || true;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl ? lineItemEl.querySelector('[data-cart-quantity-error]') : null;

                if (errorEl) {
                  errorEl.textContent = data.message;
                  errorEl.style.display = '';
                }

                if (lineItemEl) lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                if (inputEl) inputEl.value = lastValue;
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              const errEl = document.getElementById('cart-errors');
              if (errEl) errEl.textContent = theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            this.openRemoveModal(el.dataset.key, el.dataset.title, null)
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
